//引入相关api管理模块
import goods from "./goods.js";
import industry from "./industry.js";
import index from "./index.js";
import user from "./user.js";
import brand from "./brand.js";

//进行统一导出
export default {
	goods,
	industry,
	index,
	user,
	brand
}


// WEBPACK FOOTER //
// ./src/service/api.js